<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-cycle`]" width="1em" height="1em" v-bind="$attrs"><path d="M17.8471 10.7212C17.8471 10.7212 15.6755 16.1145 8.5744 13.5044L9.1202 12.1763C9.1202 12.1763 9.60368 10.8724 7.93399 11.1839L3.24223 12.4301C3.24223 12.4301 2.17719 12.7521 2.67452 13.6844L5.36195 18.2423C5.62734 18.7039 6.36353 18.9393 6.68893 18.0611L7.22549 16.7284C7.22549 16.7284 16.0101 20.0678 17.846 10.7212H17.8471ZM2.15411 8.97765C2.15411 8.97765 4.45844 3.64087 11.4926 6.42753L10.9134 7.74298C10.9134 7.74298 10.3976 9.03534 12.0765 8.76418L16.7971 7.63682C16.7971 7.63682 17.8702 7.34257 17.396 6.39638L14.8239 1.77386C14.5401 1.26499 13.8408 1.09306 13.4923 1.91925L12.9223 3.24046C12.9211 3.24046 4.2219 -0.318161 2.15295 8.97765H2.15411Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillCycle',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
